import $ from 'jquery';
import { gsap } from 'gsap';
import { StringTune } from '@fiddle-digital/string-tune';

export default function navigationMenu() {
    const $primary = $('.site-header.primary:not(.fixed)');
    const $secondary = $('.site-header.secondary:not(.fixed)');
    const $mobileMenu = $('.mobile-nav');

    const $dropdown = $('.js-lang-switch');
    const $toggle = $dropdown.find('.js-language-toggle');
    const $languageMenu = $dropdown.find('.js-language-menu');

    let isSecondaryVisible = false;
    let isPrimaryVisible = true;
    let isLocked = false;
    let lastScrollTop = 0;
    let ticking = false;

    const menuThreshold = Foundation.MediaQuery.atLeast('medium') ? 81 : 64;
    const scrollDelta = 2;

    // Init state
    gsap.set($secondary, { autoAlpha: 0, y: -15 });
    gsap.set($primary, { autoAlpha: 1, y: 0 });

    function isDesktop() {
        return Foundation.MediaQuery.atLeast('xxlarge');
    }

    function showPrimary() {
        if (isPrimaryVisible) return;
        isPrimaryVisible = true;
        gsap.to($primary, {
            autoAlpha: 1,
            y: 0,
            duration: 0.3,
            ease: 'sine.out'
        });
    }

    function hidePrimary() {
        if (!isPrimaryVisible) return;
        isPrimaryVisible = false;

        const animationProps = {
            autoAlpha: 0,
            duration: 0.2,
            ease: 'sine.in'
        };

        if (isDesktop()) {
            animationProps.y = -20;
        }

        gsap.to($primary, animationProps);
    }

    function showSecondary() {
        if (isSecondaryVisible || isLocked) return;
        isSecondaryVisible = true;
        $secondary.removeClass('invisible');
        gsap.to($secondary, {
            autoAlpha: 1,
            y: 0,
            duration: 0.15,
            ease: 'sine.out'
        });
    }

    function hideSecondary(lock = false) {
        if (!isSecondaryVisible) return;
        isSecondaryVisible = false;
        if (lock) isLocked = true;
        $secondary.addClass('invisible');
        gsap.to($secondary, {
            autoAlpha: 0,
            y: -10,
            duration: 0.15,
            ease: 'sine.in'
        });
    }

    function hideLanguageMenu() {
        if ($dropdown.hasClass('is-open')) {
            $toggle.attr('aria-expanded', false);
            $languageMenu.addClass('hide').removeClass('is-open').css('opacity', '');
            $dropdown.removeClass('is-open');
            $mobileMenu.removeClass('is-language-open');
        }
    }

    function updateHeader(scrollTop) {
        const diff = scrollTop - lastScrollTop;
        const isScrollingDown = diff > 0;
        const isNearTop = scrollTop <= 1;

        hideLanguageMenu();

        if (Math.abs(diff) < scrollDelta) {
            ticking = false;
            return;
        }

        if (scrollTop > menuThreshold) {
            hidePrimary();

            if (isScrollingDown) {
                hideSecondary();
            } else {
                showSecondary();
            }
        } else if (isNearTop) {
            isLocked = false;
            swapMenusAtTop();
        }

        lastScrollTop = scrollTop;
        ticking = false;
    }

    function swapMenusAtTop() {
        if (!isDesktop()) {
            hideSecondary();
            showPrimary();
            return;
        }

        const timeline = gsap.timeline();

        timeline
            .to($secondary, {
                autoAlpha: 0,
                y: -10,
                duration: 0.15,
                ease: 'sine.in',
                onStart: () => {
                    isSecondaryVisible = false;
                },
                onComplete: () => {
                    $secondary.addClass('invisible');
                }
            })
            .set($primary, { y: -10, autoAlpha: 0 })
            .to($primary, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                ease: 'sine.out',
                onStart: () => {
                    isPrimaryVisible = true;
                }
            });
    }


    const stringTune = StringTune.getInstance();
    stringTune.on('scroll', (scrollTop) => {
        if (!ticking) {
            window.requestAnimationFrame(() => updateHeader(scrollTop));
            ticking = true;
        }
    });

    // Swipe-away detection (alleen mobiel)
    if (!isDesktop()) {
        let touchedTopZone = false;
        let touchStartY = 0;
        let touchEndY = 0;

        window.addEventListener('touchstart', function (e) {
            const touch = e.touches[0];
            touchStartY = touch.clientY;
            touchedTopZone = touchStartY <= 80;
        }, { passive: true });

        window.addEventListener('touchmove', function (e) {
            const touch = e.touches[0];
            const deltaY = touchStartY - touch.clientY;

            if (touchedTopZone && isSecondaryVisible && deltaY > 0) {
                e.preventDefault();
            }
        }, { passive: false });

        window.addEventListener('touchend', function (e) {
            touchEndY = e.changedTouches[0].clientY;
            const swipeDistance = touchStartY - touchEndY;

            if (touchedTopZone && isSecondaryVisible && swipeDistance > 30) {
                hideSecondary(true);
            }
        });
    }

    // Mobile menu open/close
    $('.js-open-mobile-nav').on('click', function (e) {
        e.preventDefault();
        $mobileMenu.addClass('is-active');
    });

    $('.js-close-mobile-nav').on('click', function (e) {
        e.preventDefault();
        $mobileMenu.removeClass('is-active');
        hideLanguageMenu();
    });

    // Language switch
    const openDropdown = ($active) => {
        $active.find('.js-language-toggle').attr('aria-expanded', true);
        $active.find('.js-language-menu').removeClass('hide').addClass('is-open');
        $active.addClass('is-open');
        if ($active.closest('.mobile-nav').length) $mobileMenu.addClass('is-language-open');
    };

    $toggle.on('click', function (e) {
        e.preventDefault();
        const $active = $(this).closest('.js-lang-switch');
        const wasOpen = $active.hasClass('is-open');
        hideLanguageMenu();
        if (!wasOpen) openDropdown($active);
    });

    $(document).on('click', function (e) {
        if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
            hideLanguageMenu();
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            hideLanguageMenu();
        }
    });

    // Hero height

    const $el = $('.hero-fullscreen');
    if ($el.length === 0) return;

    let hasLocked = false;

    const lockHeight = function () {
        if (hasLocked) return;
        hasLocked = true;

        const vh = window.innerHeight;
        $el.css('min-height', vh + 'px');
    };

    $(window).one('scroll', lockHeight);
    $(window).one('touchmove', lockHeight);
}
